import { render, staticRenderFns } from "./MyAssignments.vue?vue&type=template&id=e4543ad2&"
import script from "./MyAssignments.vue?vue&type=script&lang=js&"
export * from "./MyAssignments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports